import { Component, OnInit, Inject } from '@angular/core';
import { Config } from '../universal-config';
import { APP_BASE_HREF } from '@angular/common';

@Component({
  selector: 'nns-reload',
  template: `
    <div></div>
  `
})
export class ReloadComponent implements OnInit {
  appBase: string;
  isBrowser: boolean;

  constructor(
    @Inject('isBrowser') isBrowser,
    @Inject(APP_BASE_HREF) appBase,
    private config: Config,
  ) {
    this.appBase = appBase;
    this.isBrowser = isBrowser;
  }

  ngOnInit() {
    if (this.isBrowser) {
      const myUrl = window.location.href;
      const myBase = window.location.origin + this.appBase;
      const boxBase = this.config.get('BOX_URL');
      const attachmentPath = myUrl.replace(myBase, '');
      const attachmentUrl = `${ boxBase }/${ attachmentPath }`;
      window.location.href = attachmentUrl
    }
  }
}
